<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} Prueba Confesional</strong></h2>


<!-- Spinners -->
<ngx-spinner [zIndex]="100" name="spUsuario" bdColor="rgba(255,255,255,0.8)"
             size="default" color="var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spTitulo" bdColor="rgba(255,255,255,0.8)"
             size="small" color="var(--accent-color)" type="ball-pulse" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spCategoria" bdColor="rgba(255,255,255,0.8)"
             size="small" color="var(--warn-color)" type="ball-pulse" [fullScreen]="false">
</ngx-spinner>

<ngx-spinner [zIndex]="100" name="spVerificar" bdColor="rgba(255,255,255,0.8)"
             size="small" color="var(--primary-color)" type="ball-pulse" [fullScreen]="false">
</ngx-spinner>

<!-- ===== FORMULARIO DE EDICIÓN/CREACIÓN ===== -->
<mat-dialog-content style="padding: 0;" *ngIf="data.accion != accionesDialog.Ver">

  <!-- Confirmación de eliminación -->
  <div *ngIf="data.accion == accionesDialog.Eliminar"
       style="padding: 32px; text-align: center;">
    <mat-card appearance="outlined" style="background: #fff3e0; border-left: 4px solid #ff9800;">
      <mat-card-content style="padding: 24px;">
        <mat-icon style="font-size: 48px; color: #ff9800; margin-bottom: 16px;">warning_amber</mat-icon>
        <h3 style="margin: 0 0 8px 0; color: #333;">¿Confirmar eliminación?</h3>
        <p style="margin: 0 0 8px 0; color: #666;">
          Estás a punto de eliminar el acceso rápido <strong>{{ data.descripcion }}</strong>
        </p>
        <p style="margin: 0; color: #999; font-size: 14px;">
          Esta acción no se puede deshacer.
        </p>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Formulario con Tabs -->
  <div *ngIf="data.accion != accionesDialog.Eliminar">
    <form [formGroup]="form">

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"  dynamicHeight>

        <!-- ===== TAB: INFORMACIÓN BÁSICA ===== -->
        <mat-tab>
           <ng-template mat-tab-label>
              <mat-icon class="tab-icon">person</mat-icon>
              Información Básica
            </ng-template>

            <!-- Sección: Datos Principales -->
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>title</mat-icon>
                </div>
                <mat-card-title>Datos Principales</mat-card-title>
                <mat-card-subtitle>Información esencial del acceso rápido</mat-card-subtitle>
              </mat-card-header>

              <mat-card-content>

                <!-- Título -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Título</mat-label>
                  <input matInput formControlName="Titulo"
                         placeholder="Ej: Google, Hotmail, Etc">
                  <mat-icon matSuffix>title</mat-icon>

                  <mat-error *ngIf="form.controls['Titulo'].hasError('required')">
                    Este campo es <strong>requerido</strong>
                  </mat-error>
                  <mat-error *ngIf="form.controls['Titulo'].hasError('maxlength')">
                    Máximo 100 caracteres
                  </mat-error>
                </mat-form-field>

                <!-- URL con botones de acción -->
                <mat-form-field appearance="outline"  class="w-100">
                  <mat-label>URL</mat-label>
                  <input matInput formControlName="Url" placeholder="https://ejemplo.com">
                  <mat-icon matSuffix>link</mat-icon>

                  <mat-error *ngIf="form.controls['Url'].hasError('required')">
                    Este campo es <strong>requerido</strong>
                  </mat-error>
                  <mat-error *ngIf="form.controls['Url'].hasError('pattern')">
                    Debe ser una URL válida (http:// o https://)
                  </mat-error>
                </mat-form-field>

                <!-- Botones de acción para URL y título -->
                <div style="display: flex; gap: 12px; margin-bottom: 16px; flex-wrap: wrap;">
                  <button mat-stroked-button color="primary" type="button"
                          (click)="setearUrlActual($event)"
                          style="display: flex; align-items: center; gap: 8px;">
                    <mat-icon>my_location</mat-icon>
                    Usar URL actual
                  </button>

                  <button mat-stroked-button color="accent" type="button"
                          (click)="sugerirTitulo()"
                          [disabled]="!form.controls['Url'].valid"
                          style="display: flex; align-items: center; gap: 8px;">
                    <mat-icon>auto_awesome</mat-icon>
                    Sugerir título
                  </button>
                </div>

                <!-- Descripción -->
                <mat-form-field appearance="outline"  class="w-100">
                  <mat-label>Descripción (opcional)</mat-label>
                  <textarea matInput formControlName="Descripcion" rows="3"
                           placeholder="Descripción corta del sitio web"></textarea>
                  <mat-icon matSuffix>description</mat-icon>
                  <mat-error *ngIf="form.controls['Descripcion'].hasError('maxlength')">
                    Máximo 200 caracteres
                  </mat-error>
                </mat-form-field>

              </mat-card-content>
            </mat-card>
        </mat-tab>

        <!-- ===== TAB: PERSONALIZACIÓN ===== -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon style="margin-right: 8px;">palette</mat-icon>
            Personalización
          </ng-template>

          <!-- Sección: Categorización -->
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>category</mat-icon>
                </div>
                <mat-card-title>Categorización</mat-card-title>
                <mat-card-subtitle>Organiza tu acceso por categorías</mat-card-subtitle>
              </mat-card-header>

              <mat-card-content>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Grupo / Categoría</mat-label>
                  <mat-select formControlName="Grupo">
                    <mat-option *ngFor="let grupo of gruposDisponibles" [value]="grupo">
                      <div style="display: flex; align-items: center; gap: 8px;">
                        <mat-icon style="font-size: 18px;">folder</mat-icon>
                        {{ grupo }}
                      </div>
                    </mat-option>
                  </mat-select>
                  <mat-icon matSuffix>category</mat-icon>
                </mat-form-field>

                <button mat-raised-button color="accent" type="button"
                        (click)="detectarCategoria()"
                        [disabled]="!form.controls['Url'].valid"
                        style="display: flex; align-items: center; gap: 8px;">
                  <mat-icon>smart_toy</mat-icon>
                  Detectar categoría automáticamente
                </button>

              </mat-card-content>
            </mat-card>

            <!-- Sección: Apariencia -->
            <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>brush</mat-icon>
                </div>
                <mat-card-title>Apariencia Visual</mat-card-title>
                <mat-card-subtitle>Personaliza el ícono y color</mat-card-subtitle>
              </mat-card-header>

              <mat-card-content style="padding: 16px 24px 24px;">

                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">

                  <!-- Ícono -->
                  <mat-form-field appearance="outline">
                    <mat-label>Ícono</mat-label>
                    <mat-select formControlName="Icono">
                      <mat-option *ngFor="let icono of iconosDisponibles" [value]="icono">
                        <div style="display: flex; align-items: center; gap: 8px;">
                          <mat-icon style="font-size: 20px;">{{ icono }}</mat-icon>
                          {{ icono }}
                        </div>
                      </mat-option>
                    </mat-select>
                    <mat-icon matSuffix [style.color]="form.get('Color')?.value">
                      {{ form.get('Icono')?.value || 'bookmark' }}
                    </mat-icon>
                  </mat-form-field>

                  <!-- Color -->
                  <mat-form-field appearance="outline">
                    <mat-label>Color</mat-label>
                    <mat-select formControlName="Color">
                      <mat-option *ngFor="let color of coloresDisponibles" [value]="color.valor">
                        <div style="display: flex; align-items: center; gap: 12px;">
                          <div style="width: 20px; height: 20px; border-radius: 50%; border: 2px solid #ddd;"
                               [style.background-color]="color.valor"></div>
                          {{ color.nombre }}
                        </div>
                      </mat-option>
                    </mat-select>
                    <div matSuffix style="width: 16px; height: 16px; border-radius: 50%; border: 1px solid #ddd; margin-right: 8px;"
                         [style.background-color]="form.get('Color')?.value"></div>
                  </mat-form-field>

                </div>

                <!-- Vista previa -->
                <mat-divider style="margin: 16px 0;"></mat-divider>
                <div style="text-align: center;">
                  <p style="margin: 0 0 8px 0; font-weight: 500; color: #666;">Vista previa:</p>
                  <mat-chip style="pointer-events: none; display: inline-flex; align-items: center; gap: 8px; padding: 8px 12px;">
                    <mat-icon [style.color]="form.get('Color')?.value" style="font-size: 18px;">
                      {{ form.get('Icono')?.value || 'bookmark' }}
                    </mat-icon>
                    {{ form.get('Titulo')?.value || 'Título del acceso' }}
                  </mat-chip>
                </div>

              </mat-card-content>
            </mat-card>
        </mat-tab>

        <!-- ===== TAB: CONFIGURACIÓN ===== -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon style="margin-right: 8px;">settings</mat-icon>
            Configuración
          </ng-template>

          <mat-card appearance="outlined">
              <mat-card-header>
                <div mat-card-avatar>
                  <mat-icon>tune</mat-icon>
                </div>
                <mat-card-title>Opciones de Visualización</mat-card-title>
                <mat-card-subtitle>Controla cómo se muestra este acceso</mat-card-subtitle>
              </mat-card-header>

              <mat-card-content >

                <!-- Favorito -->
                <mat-card appearance="outlined" style="margin-bottom: 16px; background: #fafafa;">
                  <mat-card-content style="padding: 16px;">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                      <div style="display: flex; align-items: center; gap: 12px;">
                        <mat-icon [style.color]="form.get('EsFavorito')?.value ? '#ffc107' : '#ccc'" style="font-size: 24px;">
                          {{ form.get('EsFavorito')?.value ? 'star' : 'star_border' }}
                        </mat-icon>
                        <div>
                          <h4 style="margin: 0; font-weight: 500;">Marcar como favorito</h4>
                          <p style="margin: 0; color: #666; font-size: 14px;">
                            Los favoritos aparecen al inicio de la lista
                          </p>
                        </div>
                      </div>
                      <mat-slide-toggle formControlName="EsFavorito" color="accent">
                      </mat-slide-toggle>
                    </div>
                  </mat-card-content>
                </mat-card>

                <!-- Visible -->
                <mat-card appearance="outlined" style="background: #fafafa;">
                  <mat-card-content style="padding: 16px;">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                      <div style="display: flex; align-items: center; gap: 12px;">
                        <mat-icon [style.color]="form.get('Activo')?.value ? '#4caf50' : '#ccc'" style="font-size: 24px;">
                          {{ form.get('Activo')?.value ? 'visibility' : 'visibility_off' }}
                        </mat-icon>
                        <div>
                          <h4 style="margin: 0; font-weight: 500;">Visible en la lista</h4>
                          <p style="margin: 0; color: #666; font-size: 14px;">
                            Mostrar este acceso en la lista principal
                          </p>
                        </div>
                      </div>
                      <mat-slide-toggle formControlName="Activo" color="primary">
                      </mat-slide-toggle>
                    </div>
                  </mat-card-content>
                </mat-card>

              </mat-card-content>
            </mat-card>
        </mat-tab>

      </mat-tab-group>
    </form>
  </div>

</mat-dialog-content>

<!-- ===== VISTA DE SOLO LECTURA ===== -->
<mat-dialog-content *ngIf="data.accion == accionesDialog.Ver">

  <div *ngIf="accesoRapido">

    <!-- Card: Información General -->
    <mat-card appearance="outlined" >
      <mat-card-header>
        <div mat-card-avatar [style.color]="accesoRapido.color">
          <mat-icon>{{ accesoRapido.icono || 'bookmark' }}</mat-icon>
        </div>
        <mat-card-title>{{ accesoRapido.titulo || 'Sin título' }}</mat-card-title>
        <mat-card-subtitle>
          <mat-chip style="font-size: 12px;">
            <mat-icon matChipAvatar>category</mat-icon>
            {{ accesoRapido.grupo || 'Sin categoría' }}
          </mat-chip>
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>

        <!-- URL -->
        <div style="margin-bottom: 16px;">
          <mat-label style="font-weight: 500; color: #666; display: block; margin-bottom: 4px;">
            URL:
          </mat-label>
          <a [href]="accesoRapido.url" target="_blank"
             style="color: #1976d2; text-decoration: none; display: flex; align-items: center; gap: 8px;">
            {{ accesoRapido.url }}
            <mat-icon style="font-size: 16px;">open_in_new</mat-icon>
          </a>
        </div>

        <!-- Descripción -->
        <div *ngIf="accesoRapido.descripcion" style="margin-bottom: 16px;">
          <mat-label style="font-weight: 500; color: #666; display: block; margin-bottom: 4px;">
            Descripción:
          </mat-label>
          <p style="margin: 0; color: #333;">{{ accesoRapido.descripcion }}</p>
        </div>

        <!-- Estados -->
        <div style="display: flex; gap: 8px; margin-bottom: 16px;">
          <mat-chip *ngIf="accesoRapido.esFavorito" style="background: #fff3e0; color: #f57c00;">
            <mat-icon matChipAvatar style="color: #ffc107;">star</mat-icon>
            Favorito
          </mat-chip>

          <mat-chip [style.background]="accesoRapido.activo ? '#e8f5e8' : '#ffebee'"
                    [style.color]="accesoRapido.activo ? '#2e7d32' : '#c62828'">
            <mat-icon matChipAvatar>
              {{ accesoRapido.activo ? 'visibility' : 'visibility_off' }}
            </mat-icon>
            {{ accesoRapido.activo ? 'Activo' : 'Inactivo' }}
          </mat-chip>
        </div>

      </mat-card-content>

      <mat-card-actions>
        <button mat-button color="primary" (click)="verificarUrl()">
          <mat-icon>link</mat-icon>
          Verificar URL
        </button>
        <button mat-button color="accent" (click)="duplicar()">
          <mat-icon>content_copy</mat-icon>
          Duplicar
        </button>
      </mat-card-actions>
    </mat-card>

    <!-- Card: Estadísticas -->
    <mat-card appearance="outlined">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon>analytics</mat-icon>
        </div>
        <mat-card-title>Estadísticas de Uso</mat-card-title>
        <mat-card-subtitle>Información sobre el uso del acceso</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">

          <mat-card appearance="outlined" style="text-align: center; background: #f8f9fa;">
            <mat-card-content style="padding: 16px;">
              <mat-icon style="font-size: 32px; color: #1976d2; margin-bottom: 8px;">visibility</mat-icon>
              <h2 style="margin: 0; color: #1976d2; font-size: 24px;">
                {{ accesoRapido.contadorVisitas || 0 }}
              </h2>
              <p style="margin: 0; color: #666; font-size: 14px;">Visitas totales</p>
            </mat-card-content>
          </mat-card>

          <mat-card appearance="outlined" style="text-align: center; background: #f8f9fa;">
            <mat-card-content style="padding: 16px;">
              <mat-icon style="font-size: 32px; color: #4caf50; margin-bottom: 8px;">schedule</mat-icon>
              <h3 style="margin: 0; color: #4caf50; font-size: 16px;">
                {{ accesoRapido.ultimoAcceso | date:'dd/MM/yyyy' || 'Nunca' }}
              </h3>
              <p style="margin: 0; color: #666; font-size: 14px;">Último acceso</p>
            </mat-card-content>
          </mat-card>

        </div>
      </mat-card-content>
    </mat-card>

    <!-- Card: Información de Auditoría -->
    <mat-card appearance="outlined">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon>history</mat-icon>
        </div>
        <mat-card-title>Información de Auditoría</mat-card-title>
        <mat-card-subtitle>Datos técnicos y de seguimiento</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <mat-list>

          <mat-list-item>
            <mat-icon matListItemIcon>fingerprint</mat-icon>
            <div matListItemTitle>ID del registro</div>
            <div matListItemLine>{{ accesoRapido.id }}</div>
          </mat-list-item>

          <mat-divider [inset]="true"></mat-divider>

          <mat-list-item>
            <mat-icon matListItemIcon>add_circle</mat-icon>
            <div matListItemTitle>Fecha de creación</div>
            <div matListItemLine>{{ accesoRapido.fechaCreacion | date:'dd/MM/yyyy HH:mm' }}</div>
          </mat-list-item>

          <mat-divider [inset]="true" *ngIf="accesoRapido.fechaModificacion"></mat-divider>

          <mat-list-item *ngIf="accesoRapido.fechaModificacion">
            <mat-icon matListItemIcon>edit</mat-icon>
            <div matListItemTitle>Última modificación</div>
            <div matListItemLine>{{ accesoRapido.fechaModificacion | date:'dd/MM/yyyy HH:mm' }}</div>
          </mat-list-item>

          <mat-divider [inset]="true"></mat-divider>

          <mat-list-item>
            <mat-icon matListItemIcon>person</mat-icon>
            <div matListItemTitle>Creado por</div>
            <div matListItemLine>{{ accesoRapido.creadoPor || 'Usuario del sistema' }}</div>
          </mat-list-item>

          <mat-divider [inset]="true"></mat-divider>

          <mat-list-item>
            <mat-icon matListItemIcon>sort</mat-icon>
            <div matListItemTitle>Orden en la lista</div>
            <div matListItemLine>Posición {{ accesoRapido.orden }}</div>
          </mat-list-item>

        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>

</mat-dialog-content>

<!-- ===== ACCIONES DEL DIÁLOGO ===== -->
<mat-divider></mat-divider>

<mat-dialog-actions align="end" style="padding: 16px;">

  <app-button-cancel-dialog></app-button-cancel-dialog>

  <app-button-add *ngIf="data.accion == accionesDialog.Agregar"
                  [disabled]="!form.valid || guardando"
                  (click)="agregar()">
  </app-button-add>

  <app-button-save [disabled]="!form.valid || guardando"
                   [isDialogClose]="true"
                   (saveClicked)="modificar()"
                   (cancelClicked)="cancelar()"
                   *ngIf="data.accion == accionesDialog.Modificar">
  </app-button-save>

  <app-button-delete (click)="eliminar()"
                     (cancelClicked)="cancelar()"
                     *ngIf="data.accion == accionesDialog.Eliminar"
                     [disabled]="guardando"
                     [isDialogClose]="true">
  </app-button-delete>

</mat-dialog-actions>
